var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.watercraft)?_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('img',_vm._g(_vm._b({staticStyle:{"margin":"3px"},attrs:{"src":'/watercraft/' + _vm.watercraft + '.svg',"height":"36","width":"36"}},'img',attrs,false),on))]}}],null,false,2024705388)},[_c('span',[_vm._v(_vm._s(_vm.watercraft))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }